
export default function BoardBottom({children}){

    return(
        <div className="board-bottom">
            {children}
        </div>
    )
}